var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { BaseDialog, BaseDialogState } from '@/app/UIComponents/BaseDialog';
import { FileUploadDialog, FileUploadDialogState } from './FileUploadDialog';
export class ReplaceDialogState {
    constructor() {
        this.basedialog = new BaseDialogState();
        this.replaceinfo = [];
        this.uploadState = new FileUploadDialogState();
        this.letrid = "";
        makeObservable(this);
        this.basedialog.setHeaderLabel("Replace");
        this.basedialog.setHideFooter(true);
        this.uploadState.singleFileMode = true;
        this.uploadState.fileUploadedCb = (uploaded) => {
            var _a;
            const nversion = {
                name: uploaded.filename,
                size: uploaded.size,
                accesskey: uploaded.accesskey,
                replacenumber: this.replaceinfo.length + 1,
                filid: uploaded.fileid,
                boxid: uploaded.databoxid,
                isDownloadable: uploaded.isDownloadable
            };
            if (this.activeversion !== undefined) {
                this.addReplace(this.activeversion);
            }
            this.uploadState.setOpen(false);
            this.uploadState.clear();
            (_a = this.replaceaddcb) === null || _a === void 0 ? void 0 : _a.call(this, nversion);
        };
    }
    setOpen(open) {
        this.basedialog.setOpen(open);
    }
    addReplaces(infos) {
        infos.forEach((inf) => this.addReplace(inf));
    }
    addReplace(rinfo) {
        this.replaceinfo.push(rinfo);
    }
    setShowUploader(show) {
        this.uploadState.letrid = this.letrid;
        this.uploadState.setOpen(show);
    }
    clear() {
        this.replaceinfo = [];
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], ReplaceDialogState.prototype, "replaceinfo", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ReplaceDialogState.prototype, "clear", null);
let ReplaceDialog = class ReplaceDialog extends React.Component {
    constructor(prop) {
        super(prop);
    }
    addReplace() {
        this.props.state.setShowUploader(true);
    }
    revert(v) { }
    buildReplace(v, index) {
        return React.createElement(Flex, { align: 'center', backgroundColor: index % 2 === 0 ? '#e0e0e0' : '#ffffff', key: v.boxid, height: '50px', borderBottomColor: 'lightgray', borderBottomWidth: '1px' },
            React.createElement(Text, { w: '80%' }, v.name + " (" + v.replacenumber + ")"),
            React.createElement(Box, { w: '20%', alignItems: 'flex-end' },
                React.createElement(Text, { w: '100%', cursor: 'pointer', onClick: () => this.revert(v) }, "Revert")));
    }
    renderUI() {
        return React.createElement(Box, null,
            React.createElement(Button, { onClick: () => this.addReplace() }, "Add Replace"),
            React.createElement(Box, { mt: '10px', minH: '50px', maxH: this.props.bodyHeight, overflowY: 'auto' }, this.props.state.replaceinfo.slice().sort((r1, r2) => r1.replacenumber - r2.replacenumber).reverse()
                .map((v, index) => this.buildReplace(v, index))));
    }
    render() {
        return React.createElement(React.Fragment, null,
            React.createElement(FileUploadDialog, { state: this.props.state.uploadState }),
            React.createElement(BaseDialog, { body: this.renderUI(), state: this.props.state.basedialog }));
    }
};
ReplaceDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ReplaceDialog);
export { ReplaceDialog };
